const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
const TOKEN_KEY = "my-car-marketplace-token";

export const getMarketplaceToken = () => window.localStorage.getItem(TOKEN_KEY);
export const getMarketplaceUser = () => {
  try { return JSON.parse(window.localStorage.getItem("my-car-marketplace-user") || "null"); } catch { return null; }
};
export const logoutMarketplace = () => {
  window.localStorage.removeItem(TOKEN_KEY);
  window.localStorage.removeItem("my-car-marketplace-user");
};
export const marketplaceHeaders = () => {
  if (window.localStorage.getItem("my-car-admin-token")) return {};
  const token = getMarketplaceToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};
export const isSellerAuthenticated = () => getMarketplaceUser()?.role === "seller" && Boolean(getMarketplaceToken());

async function post(path, body) {
  const response = await fetch(`${API_URL}/marketplace-auth/${path}`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.message || "Unable to complete the request.");
  window.localStorage.setItem(TOKEN_KEY, data.token);
  window.localStorage.setItem("my-car-marketplace-user", JSON.stringify(data.user));
  return data;
}
export const signupMarketplace = (data) => post("signup", data);
export const loginMarketplace = (email, password) => post("login", { email, password });
